import React from 'react';
import PropTypes from 'prop-types';
import { FolderAssetType } from '../../../model';
import {
  AdsStudioImageAssetsGridCell as DefaultImageGridCell,
  AdsStudioVideoAssetsGridCell as DefaultVideoGridCell,
} from '..';

export const GridCellFactory = (props) => {
  const { item } = props;
  const { folderAssetType } = item || {};

  switch (folderAssetType) {
    case FolderAssetType.Image:
      return <DefaultImageGridCell {...props} />;
    case FolderAssetType.Video:
      return <DefaultVideoGridCell {...props} />;
    default:
      return null;
  }
};

GridCellFactory.propTypes = {
  item: PropTypes.shape({
    folderAssetType: PropTypes.string.isRequired,
  }),
};

GridCellFactory.defaultProps = {
  item: null,
};
